import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';

export type RevokeScimTokenModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** How the admin tells this token apart: its creation date. */
  createdOn: string;
  /** The identity provider is not calling with it any more, as far as the API has seen. */
  isUnused: boolean;
  isRevoking?: boolean;
  onConfirm: () => void;
};

export const RevokeScimTokenModal = ({
  open,
  onOpenChange,
  createdOn,
  isUnused,
  isRevoking,
  onConfirm,
}: RevokeScimTokenModalProps) => (
  // Held open while revoking, so that the toast is the outcome the admin sees
  <Dialog open={open} onOpenChange={(next) => (next || !isRevoking) && onOpenChange(next)}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Revoke the token created on {createdOn}?</DialogTitle>
        <DialogDescription>
          {isUnused
            ? 'Your identity provider has not used it for 90 days. Any request made with it is refused from now on; this cannot be undone.'
            : 'Any request your identity provider makes with it is refused from now on, and this cannot be undone. When rotating, switch your identity provider to the other token first.'}
        </DialogDescription>
      </DialogHeader>

      <DialogFooter>
        <Button
          type="button"
          variant="outline"
          disabled={isRevoking}
          onClick={() => onOpenChange(false)}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="destructive"
          onClick={onConfirm}
          isLoading={isRevoking}
        >
          Revoke token
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
